export const parseLocationString = (locationValue: string) => {
  const parts = locationValue.split(',').map((s) => s.trim())
  let city = '',
    state = '',
    zip = ''

  if (parts.length === 1) {
    const singlePart = parts[0]
    if (/^\d{5}(-\d{4})?$/.test(singlePart)) {
      zip = singlePart
    } else {
      city = singlePart
    }
  } else if (parts.length === 2) {
    ;[city, state] = parts
  } else if (parts.length === 3) {
    ;[city, state, zip] = parts
  }

  return { city, state, zip }
}
